var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAIIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_2436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.67061 3.23488C6.77979 1.52453 8.67641 0.47462 10.7254 0.449219C14.0614 0.449219 16.7794 3.14174 16.8048 6.47775C16.8048 6.74023 16.7878 7.00271 16.7455 7.25672C16.7201 7.41759 16.7794 7.57847 16.9064 7.68007L18.8199 11.0161H16.9656C16.7116 11.0161 16.5 11.2278 16.5 11.4818V16.1217H16.3137C14.9674 16.0286 11.7923 15.4952 10.6746 14.6738C10.0311 14.1574 9.49771 13.5223 9.10823 12.7942C9.02356 12.701 8.96429 12.591 8.92195 12.4809C8.87115 12.3369 8.74414 12.2353 8.6002 12.2015C8.4986 12.1761 8.40546 12.1337 8.31233 12.0829C7.18621 11.5918 6.2379 10.7705 5.58594 9.7291",
    stroke: "#183243",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75781 3.54688H8.25292",
    stroke: "#183243",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18653 4.20899C9.62609 4.20899 9.98243 3.85265 9.98243 3.41309C9.98243 2.97353 9.62609 2.61719 9.18653 2.61719C8.74696 2.61719 8.39062 2.97353 8.39062 3.41309C8.39062 3.85265 8.74696 4.20899 9.18653 4.20899Z",
    stroke: "#183243",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.449219 6.72266H5.9528",
    stroke: "#183243",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87403 7.38282C7.31359 7.38282 7.66993 7.02648 7.66993 6.58692C7.66993 6.14735 7.31359 5.79102 6.87403 5.79102C6.43446 5.79102 6.07812 6.14735 6.07812 6.58692C6.07812 7.02648 6.43446 7.38282 6.87403 7.38282Z",
    stroke: "#183243",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47266 9.43164H7.96777",
    stroke: "#183243",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.20312 12.7773H8.69824",
    stroke: "#183243",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21484 0.449219H10.7184",
    stroke: "#183243",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89746 10.1016C9.33703 10.1016 9.69337 9.74523 9.69337 9.30567C9.69337 8.8661 9.33703 8.50977 8.89746 8.50977C8.4579 8.50977 8.10156 8.8661 8.10156 9.30567C8.10156 9.74523 8.4579 10.1016 8.89746 10.1016Z",
    stroke: "#183243",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_2436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.271,
    height: 16.57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIIcon);
export default __webpack_public_path__ + "static/media/aIIcon.42c15337c5e60d6bbff576d6f5711bb8.svg";
export { ForwardRef as ReactComponent };